import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Actions, Store } from '@ngxs/store';
import { ModuleManagersService } from 'app/library/module-managers/services/module-managers.service';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleCategory } from 'app/library/module/enums/moduleCategory';
import { ModuleStatuses } from 'app/library/module/models/module-statuses';
import { ModuleGlobalService } from 'app/library/module/services/module-global.service';
import { MaxBrainTag } from 'app/library/tag/models/tag.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Module } from '../../../module/models/module.model';
import { SortMyUnpublishedModules } from '../../../my-unpublished-modules/actions/index';
import { TagMultiSelectService } from '../../../tag/services/multi-select.service';
import { UnpublishedModuleDataSource } from './unpublished-module-datasource';

@Component({
    selector: 'app-my-unpublished-modules-list-table',
    templateUrl: './my-unpublished-modules-list-table.component.html',
    styleUrls: ['./my-unpublished-modules-list-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyUnpublishedModulesListTableComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    myModule$: Observable<Module[]>;

    @Input()
    searchTerm: string;

    @Output()
    clickedTag = new EventEmitter<MaxBrainTag>();

    @ViewChild(MatSort)
    sort: MatSort;

    profileId = this._store.selectSnapshot(UserState).me;
    dataSource: UnpublishedModuleDataSource;
    displayedColumns = ['avatar', 'name', 'startDate', 'endDate', 'status'];
    ModuleKind = ModuleKind;

    moduleStatuses = ModuleStatuses;

    constructor(
        public tagMultiSelectService: TagMultiSelectService,
        private _action$: Actions,
        private _store: Store,
        private moduleGlobalService: ModuleGlobalService,
        private _moduleManagersService: ModuleManagersService
    ) {
        super();
    }

    ngOnInit(): void {
        this.dataSource = new UnpublishedModuleDataSource(this.myModule$, this._store, this._action$, this.tagMultiSelectService);

        setTimeout(() => {
            this.sort.sortChange.pipe(takeUntil(this._unsubscribeAll)).subscribe((sort) => {
                this._store.dispatch(new SortMyUnpublishedModules(sort));

                this.loadUnpublishedModulesPage();
            });
        });
    }

    filterByTag(tag: MaxBrainTag): void {
        this.clickedTag.emit(tag);
    }

    loadUnpublishedModulesPage(): void {
        const user = this._store.selectSnapshot(UserState.getEntity);

        this.dataSource.loadModules(
            ModuleCategory.Unpublished,
            this.searchTerm,
            this.sort.active,
            this.sort.direction,
            100,
            1,
            user?.id || this.profileId,
            this.tagMultiSelectService.selectedTags.map((tag) => parseInt(tag.id))
        );
    }

    goToModule(module: Module): void {
        this.moduleGlobalService.setParentUrl(window.location.pathname);
        this._moduleManagersService.goToModule(this.profileId, module, 'overview');
    }

    visualLength(text: string): number {
        const ruler = document.getElementById('ruler-2');
        ruler.innerHTML = text;
        const toReturn = ruler.offsetWidth;
        ruler.innerHTML = '';
        return toReturn;
    }
}
